// Configuración de navegación por defecto
import {
  Building,
  FileCheck,
  // FileText,
  Layers,
  LayoutDashboard,
  Package,
  Users
  // UserSearch
} from 'lucide-react'

export const defaultNavigationConfig = {
  assessments: [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: LayoutDashboard,
      href: '/dashboard'
    },
    {
      id: 'assessments',
      label: 'Assessments',
      icon: FileCheck,
      href: '/assessments'
      // children: [
      //   {
      //     id: 'assessments-in-progress',
      //     label: 'En curso',
      //     href: '/assessments?status=in-progress',
      //     badge: 3,
      //     badgeVariant: 'primary' as const
      //   },
      //   {
      //     id: 'assessments-completed',
      //     label: 'Finalizados',
      //     href: '/assessments?status=completed'
      //   },
      //   {
      //     id: 'assessments-drafts',
      //     label: 'Borradores',
      //     href: '/assessments?status=draft',
      //     badge: 1
      //   }
      // ]
    }
  ],

  admin: [
    {
      id: 'admin-catalogs',
      label: 'Catálogos',
      icon: Package,
      children: [
        {
          id: 'admin-catalogs-technologies',
          label: 'Tecnologías',
          href: '/admin/catalogs/technologies'
        },
        { id: 'admin-catalogs-services', label: 'Servicios', href: '/admin/catalogs/services' },
        { id: 'admin-catalogs-projects', label: 'Proyectos', href: '/admin/catalogs/projects' },
        { id: 'admin-catalogs-policies', label: 'Políticas', href: '/admin/catalogs/policies' },
        {
          id: 'admin-catalogs-objectives',
          label: 'Objetivos de Control',
          href: '/admin/catalogs/objectives'
        }
      ]
    },
    {
      id: 'admin-frameworks',
      label: 'Frameworks',
      icon: Layers,
      children: [
        {
          id: 'admin-frameworks-subcategories',
          label: 'Subcategorías',
          href: '/admin/frameworks/subcategories'
        },
        {
          id: 'admin-frameworks-categories',
          label: 'Categorías',
          href: '/admin/frameworks/categories'
        },
        {
          id: 'admin-frameworks-functions',
          label: 'Funciones',
          href: '/admin/frameworks/functions'
        },
        { id: 'admin-frameworks-versions', label: 'Versiones', href: '/admin/frameworks' }
      ]
    },
    {
      id: 'admin-organizations',
      label: 'Organizaciones',
      icon: Building,
      href: '/admin/organizations'
    },
    {
      id: 'admin-users',
      label: 'Usuarios',
      icon: Users,
      href: '/admin/users'
    }
    // {
    //   id: 'admin-sessions',
    //   label: 'Sesiones',
    //   icon: UserSearch,
    //   href: '/admin/sessions'
    // }
  ]
}
